import { render } from "./ShortcutsModal.vue?vue&type=template&id=7ff3864c"
import script from "./ShortcutsModal.vue?vue&type=script&lang=js"
export * from "./ShortcutsModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__